import { TRANSACTION_TYPES } from './constants';
import { getAmountCents } from './money';
import { isRealizedTransaction } from './transactions';

const emptySummary = () => ({
  totalIncomeCents: 0,
  totalExpenseCents: 0,
  legacyBalanceCents: 0,
  realizedIncomeCents: 0,
  realizedExpenseCents: 0,
  plannedIncomeCents: 0,
  plannedExpenseCents: 0,
  realizedBalanceCents: 0,
  projectedBalanceCents: 0,
  invalidAmountCount: 0,
  invalidStatusCount: 0,
});

export const calculateFinancialSummary = ({ receitas = [], despesas = [] } = {}) => {
  const summary = emptySummary();

  const addRecords = (records, type) => {
    records.forEach((record) => {
      const amountCents = getAmountCents(record);
      if (amountCents === null) {
        summary.invalidAmountCount += 1;
        return;
      }

      if (type === TRANSACTION_TYPES.INCOME) {
        summary.totalIncomeCents += amountCents;
      } else {
        summary.totalExpenseCents += amountCents;
      }

      const realized = isRealizedTransaction({ ...record, tipo: type });
      if (realized === null) {
        summary.invalidStatusCount += 1;
        return;
      }

      if (type === TRANSACTION_TYPES.INCOME) {
        if (realized) summary.realizedIncomeCents += amountCents;
        else summary.plannedIncomeCents += amountCents;
      } else if (realized) {
        summary.realizedExpenseCents += amountCents;
      } else {
        summary.plannedExpenseCents += amountCents;
      }
    });
  };

  addRecords(receitas, TRANSACTION_TYPES.INCOME);
  addRecords(despesas, TRANSACTION_TYPES.EXPENSE);

  summary.legacyBalanceCents = summary.totalIncomeCents - summary.totalExpenseCents;
  summary.realizedBalanceCents =
    summary.realizedIncomeCents - summary.realizedExpenseCents;
  summary.projectedBalanceCents =
    summary.realizedBalanceCents +
    summary.plannedIncomeCents -
    summary.plannedExpenseCents;

  return summary;
};

export const calculateFinancialSummaryForTransactions = (transactions = []) => calculateFinancialSummary({
  receitas: transactions.filter((item) => item.tipo === TRANSACTION_TYPES.INCOME),
  despesas: transactions.filter((item) => item.tipo === TRANSACTION_TYPES.EXPENSE),
});

export const calculateBalanceForecastCents = (currentTransactions = [], upcomingTransactions = []) => {
  const current = calculateFinancialSummaryForTransactions(currentTransactions);
  const upcoming = calculateFinancialSummaryForTransactions(upcomingTransactions);
  return current.realizedBalanceCents + upcoming.plannedIncomeCents - upcoming.plannedExpenseCents;
};
